import { render } from "./ReceiveMoneyView.vue?vue&type=template&id=6e243405"
import script from "./ReceiveMoneyView.vue?vue&type=script&lang=js"
export * from "./ReceiveMoneyView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__